<template>
  <div class="animated fadeIn">
    <div v-if='this.window.width > 992'>
      <div v-if='sections.length > 0 && !print'>
        <b-tabs content-class='mt-3' v-model='currentTab' :class="[{ 'custom-content': customContent },'top-nav-tabs']">
          <b-tab @click="loadWidgets(section.id, section.custom_content)" v-for='section in sections' :key='section.order + "_" + section.id' :title="section.name">
            <CustomContent v-if="section.custom_content === true"/>
            <DashboardGrid v-else-if="section.custom_content !== true && widgets.length > 0" :widgets="widgets" :section_id="section.id" :col_num="4" :print="print"/>
          </b-tab>
        </b-tabs>
      </div>
      <div v-else ref='content'>
        <DashboardGrid v-if="widgets.length > 0" :widgets="widgets" :col_num="4" :print="print"/>
      </div>
    </div>
    <div v-else>
      <div v-if='sections.length > 0'>
        <v-select v-model="currentTabModel"
                  :options="sections"
                  label="name"
                  @input="selectSection(currentTabModel)"
                  :clearable="false"
                  style="padding: 0 10px;" />
        <CustomContent v-if="currentTabModel.custom_content === true"/>
        <DashboardGrid v-else-if="currentTabModel.custom_content !== true && widgets.length > 0" :widgets="widgets" :section_id="currentTabModel.id" :col_num="1" :print="print"/>
      </div>
      <div v-else ref='content'>
        <DashboardGrid v-if="widgets.length > 0" :widgets="widgets" :col_num="1" :print="print"/>
      </div>
    </div>
    <div class="bottom-nav" v-if='sections.length > 1'>
      <b-row>
        <b-col xs="6">
          <a class="left" @click="prevSection()" v-show='sections.length > 2 || currentTab === 1'><i class="fa fa-arrow-left" aria-hidden="true"></i> Go to {{ prevTab }}</a>
        </b-col>
        <b-col xs="6">
          <a class="right" @click="nextSection()" v-show='sections.length > 2 || currentTab === 0'>Go to {{ nextTab }} <i class="fa fa-arrow-right" aria-hidden="true"></i></a>
        </b-col>
      </b-row>
    </div>
    <div v-if='this.getQuickDate'>
      <div v-show='this.window.width > 992' class="mx-auto" :class="{'hide-quick-date': hideQuickDate}" id="quick-date-picker">
        <b-nav pills>
          <b-nav-item v-for="(date, quickDate, index) in quickDates" :key="`date-${index}`"
          @click="quickDatePicker(date, quickDate)" class="mx-auto">{{ quickDate }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <widget-modal />
    <section-modal />
    <edit-section-modal />
    <b-modal size="xl" ref="ad-preview-modal" id="ad-preview-modal" title="Ad Preview">
      <div v-html="currentAdPreview"></div>
    </b-modal>
    <b-modal id="export-modal" :title="`Download ${exportType}`" hide-footer>
      <b-form @submit="saveExport" @reset="buildTitle">
        <div class="row">
          <b-form-group
            class="col-sm-12"
            id="input-download"
            label="Download Name:"
            label-for="download"
            >
            <b-form-input
              id="dashboard-download"
              v-model="exportTitle"
              required
              placeholder="Enter Name"
              ></b-form-input>
          </b-form-group>
        </div>
        <div class="mt-3">
          <b-button type="submit" variant="primary">Download</b-button>
          <b-button class="ml-2" type="reset">Default Name</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import CustomContent from './CustomContent'
import VueGridLayout from 'vue-grid-layout'
import DashboardGrid from './DashboardGrid'
import NumberWidget from './widgets/NumberWidget'
import DoughnutWidget from './widgets/DoughnutWidget'
import LinechartWidget from './widgets/LinechartWidget'
import BarWidget from './widgets/BarWidget'
import TableWidget from './widgets/TableWidget'
import GaugeWidget from './widgets/GaugeWidget'
import GalleryWidget from './widgets/GalleryWidget'
import WidgetModal from '@/views/modals/WidgetModal'
import SectionModal from '@/views/modals/SectionModal'
import EditSectionModal from '@/views/modals/EditSectionModal'
import vSelect from 'vue-select'
import { Callout } from '@coreui/vue'
import { mapGetters, mapMutations } from 'vuex'
import Moment from 'moment'
import XLSX from 'xlsx'
import PptxGenJS from 'pptxgenjs'
import jspdf from 'jspdf'
import html2canvas from 'html2canvas'
import FileSaver from 'file-saver'
import { dashboardMixins } from '@/shared/DashboardMixins'
import _ from 'lodash'

export default {
  name: 'Dashboard',
  mixins: [dashboardMixins],
  components: {
    CustomContent,
    DashboardGrid,
    VueGridLayout,
    Callout,
    NumberWidget,
    DoughnutWidget,
    LinechartWidget,
    BarWidget,
    TableWidget,
    GaugeWidget,
    GalleryWidget,
    WidgetModal,
    SectionModal,
    EditSectionModal,
    XLSX,
    PptxGenJS,
    html2canvas,
    jspdf,
    vSelect
  },

  props: ['id', 'print'],

  data: function () {
    return {
      widgets: [],
      sections: [],
      currentTab: 0,
      pptx: null,
      currentAdPreview: '',
      currentTabModel: null,
      exportID: null,
      exportType: null,
      exportTitle: '',
      hideQuickDate: false,
      customContent: false,
      quickDates: {
        '1D': Moment().subtract(1, 'day'),
        '1W': Moment().subtract(1, 'week'),
        '1M': Moment().subtract(1, 'month'),
        '3M': Moment().subtract(90, 'days'),
        '1Y': Moment().subtract(1, 'year')
      }
    }
  },

  computed: {
    ...mapGetters(['dashboardData']),
    addWidgetButtonVisible () {
      return this.$store.getters.widgetSettingsVisible
    },
    nextTab () {
      if (this.currentTab < this.sections.length - 1) {
        return this.sections[this.currentTab + 1].name
      } else {
        return this.sections[0].name
      }
    },
    prevTab () {
      if (this.currentTab > 0) {
        return this.sections[this.currentTab - 1].name
      } else {
        return this.sections[this.sections.length - 1].name
      }
    },
    getQuickDate () {
      return this.$store.getters.quickDateShow
    }
  },

  created () {
    this.$store.dispatch('getDashboard', this.$route.params.id)
    this.resetWidgetData()
    this.$root.$on('customContent', (visible) => {
      this.customContent = visible
    })
    this.$eventBus.$on('changeCurrentTab', (sectionId) => this.changeCurrentTab(sectionId))
    this.$eventBus.$on('changeCurrentClient', () => this.loadWidgets())
    this.$eventBus.$on('reloadWidgets', (section) => this.loadWidgets(section))
    this.loadSections()
    this.$store.commit('setWidgetsSettingsVisibility', false)
    if (process.env.NODE_ENV === 'development'){
      this.$store.commit('setWidgetsSettingsVisibility', true)
    }
    this.$eventBus.$on('navSection', (s) => {this.selectSection(s)})
    this.$eventBus.$on('downloadPDF', (filename) => {this.printPdf(filename)})
    this.$eventBus.$on('downloadXLSX', (filename) => {this.downloadXLSX(filename)})
    this.$eventBus.$on('downloadPPTX', this.downloadPPTX)
    this.$eventBus.$on('slidesReady', this.exportSlides)
    this.$eventBus.$on('previewAd', (payload) => {this.showAdPreview(payload)})
    this.$eventBus.$on('exportWidget', (exportInfo) => {this.exportWidget(exportInfo)})
    this.getWindowWidth()
    if (this.$route.query.tab) {
      this.currentTab = parseInt(this.$route.query.tab)
    }
    window.addEventListener('scroll', this.showQuickDate)
  },

  destroyed () {
    window.removeEventListener('scroll', this.showQuickDate);
  },

  beforeDestroy(){
    this.$eventBus.$off('changeCurrentClient')
    this.$eventBus.$off('downloadPDF')
    this.$eventBus.$off('downloadXLSX')
    this.$eventBus.$off('downloadPPTX')
    this.$eventBus.$off('slidesReady')
    this.$eventBus.$off('exportWidget')
    this.$eventBus.$off('navSection')
  },

  methods: {
    ...mapMutations(['resetWidgetData']),
    changeCurrentTab (sectionId) {
      let section = this.sections.find( section => section.id == sectionId )
      this.selectSection(section)
    },
    saveExport (e) {
      e.preventDefault()
      this.exportType === 'PDF' ? this.exportWidgetPDF() : this.exportWidgetXlSX()
      this.$root.$emit('bv::hide::modal', 'export-modal')
    },

    buildTitle () {
      this.exportTitle = this.dashboardData.find( w => w.id === this.exportID ).title
      this.exportTitle = this.exportTitle.replace(/\s+/g, '_').toLowerCase()
    },

    exportWidget (info) {
      this.exportID = info.widgetID
      this.exportType = info.exportType
      this.buildTitle()
      this.$root.$emit('bv::show::modal', 'export-modal')
    },

    exportWidgetXlSX () {
      let widget = this.dashboardData.find( w => w.id === this.exportID )
      let filename = this.exportTitle
      if (filename.length >= 25) {
        filename = filename.substring(0, 25); //max xlsx filename length + ext
      }
      filename += '.xlsx'
      let book = XLSX.utils.book_new()
      let data = []
      let labels = []
      if (widget.labels[0].key) {
        labels = widget.labels.map( l => l.key )
        widget.data.forEach(row => data.push(Object.values(_.pick(row,labels))))
      } else {
        labels = widget.labels
        widget.data[0].forEach((row, index) => {
          data.push( [labels[index], row])
        })
      }
      let sheet = XLSX.utils.aoa_to_sheet(data);
      let sheetTitle = `${widget.title} - ${widget.id}`
      sheetTitle = sheetTitle.substring(0, 30)
      sheetTitle = sheetTitle.replace(/\W/g, '').toLowerCase()
      XLSX.utils.book_append_sheet(book, sheet, sheetTitle)
      XLSX.writeFile(book, filename);
    },

    exportWidgetPDF () {
      let widget = this.dashboardData.find( w => w.id === this.exportID )
      let filename = this.exportTitle
      filename = `${filename.replace(/\s/g, "X")}.pdf`
      this.$parent.pdfButtonClass = 'fa-cog fa-spin'
      this.$http.get('/print_widget', {
        responseType:'arraybuffer',
        params: {
          widget_id: widget.id,
          client: this.$store.getters.currentClient.id,
          client_domain: this.$store.getters.currentClient.domain,
          start_date: this.$store.getters.startDate,
          end_date: this.$store.getters.endDate,
          current_tab: this.currentTab,
          compare_start_date: this.$store.getters.compareStartDate,
          compare_end_date: this.$store.getters.compareEndDate
        }
      }).then((response) => {
       const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        FileSaver.saveAs(blob, filename);
        })
    },

    selectSection (e) {
      if (typeof(e) === "number") {
        e = this.sections.filter((s) => {
          return s.id === e
        })[0]
      }
      if (e.custom_content === true) {
        this.$root.$emit('customContent', true)
      } else {
        this.$root.$emit('customContent', false)
      }
      this.currentTab = this.sections.indexOf(e)
      this.currentTabModel = this.sections[this.currentTab]
      this.loadWidgets(e.id)
    },

    showAdPreview (src) {
      this.currentAdPreview = `<iframe src="${src}" title="description" width="540" height="690"></iframe>`
      this.$refs['ad-preview-modal'].show()
    },

    printPdf (filename = 'dashboard.pdf') {
      filename = `${filename.replace(/\s/g, "X")}.pdf`
      this.$parent.pdfButtonClass = 'fa-cog fa-spin'
      this.$http.get('/print_dashboard', {
        responseType:'arraybuffer',
        params: {
          dashboard_id: this.$route.params.id,
          client: this.$store.getters.currentClient.id,
          client_domain: this.$store.getters.currentClient.domain,
          start_date: this.$store.getters.startDate,
          end_date: this.$store.getters.endDate,
          current_tab: this.currentTab,
          compare_start_date: this.$store.getters.compareStartDate,
          compare_end_date: this.$store.getters.compareEndDate
        }
      }).then((response) => {
       const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        FileSaver.saveAs(blob, filename);
        this.$parent.pdfButtonClass = 'fa-file-pdf-o'
        })
    },

    downloadPdf () {
      this.$parent.pdfButtonClass = 'fa-cog fa-spin'
      var page = 1
      var pageOffset = 0
      var pdf = new jspdf('p', 'pt', 'letter')
      var nodes = document.body.querySelectorAll('.tab-pane.active div.card')
      if (nodes.length === 0){
        nodes = document.body.querySelectorAll('div.card')
      }
      var elements = []
      nodes.forEach((node) => elements.push(node))
      elements = elements.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top )
      elements.forEach(function(element, index, arr){
        html2canvas(element, {logging: false}).then(function(canvas){
          var imgData = canvas.toDataURL('image/png')
          var coords = element.getBoundingClientRect()
          var left = (coords.left + window.scrollX - 100) * 0.33 // to convert px to pt
          var top = (coords.top + window.scrollY) * 0.33 - pageOffset
          var width = coords.width * 0.33
          var height = coords.height * 0.33
          if ((coords.bottom+window.scrollY)*0.33 > page*770){ // 770 is the Letter height in pt minus margins
            pdf.addPage()
            top = 10
            pageOffset = page*792 - 70 // avg margin
            page = page + 1
          }
          pdf.addImage(imgData, 'PNG', left, top, width, height)
          if (Object.is(arr.length - 1, index)) {
            this.$parent.pdfButtonClass = 'fa-file-pdf-o'
            setTimeout(function(){
              pdf.save('dashboard.pdf')
            }, 1000)
          }
        }.bind(this))
      }.bind(this))
    },

    downloadXLSX (filename = 'dashboard.xlsx') {
      filename = `${filename.replace(/\s/g, "")}.xlsx`
      let book = XLSX.utils.book_new()
      this.dashboardData.forEach( (widget) => {
        let data = []
        let labels = widget.labels.map( l => l.key )
        data.push(labels)
        widget.data.forEach(row => data.push(Object.values(_.pick(row,labels))))
        let sheet = XLSX.utils.aoa_to_sheet(data);
        let sheetTitle = `${widget.title} - ${widget.id}`
        sheetTitle = sheetTitle.replace(/\W/g, '').toLowerCase()
        sheetTitle = sheetTitle.substring(0, 30)
        XLSX.utils.book_append_sheet(book, sheet, sheetTitle)
      } )
      XLSX.writeFile(book, filename);
    },

    downloadPPTX () {
      var vm = this
      let refs = this.widgets.map( w => `widgetppt${w.id}`)
      let slidesCounter = 0
      vm.pptx = new PptxGenJS()
      refs.forEach(ref => {
        let el = document.getElementById(ref)
        html2canvas(el).then(function(canvas) {
          var myImage = canvas.toDataURL("image/png");
          slidesCounter++
          vm.pptx.addNewSlide('TITLE',{bkgd: 'FFFFFF'}).addImage({ data:myImage, x:2.0, y: 0.0, w:6.0, h:5.5 })
          if(slidesCounter === refs.length){
            vm.$eventBus.$emit('slidesReady')
          }
        });
      })
    },

    exportSlides () {
      this.pptx.save()
    },

    loadSections (newSectionId = null) {
      this.$http.get('/dashboards/'+ this.$route.params.id)
        .then(function(response){
          this.sections = response.data.sections.map((section) => {
            return {
              id: section.id,
              name: section.name,
              order: section.order,
              custom_content: section.custom_content
            }
          })
          this.sections.sort((a, b) => a.order - b.order)
          var section = this.sections.find((section) => parseInt(section.id,10) === parseInt(newSectionId, 10))
          this.$eventBus.$emit('loadSections', this.sections)
          setTimeout(()=> {this.currentTab = this.sections.indexOf(section)}, 200) // give time to rerender
          if (this.window.width < 768) {
            this.currentTabModel = this.sections[this.currentTab]
          }
          this.loadWidgets(newSectionId)
        }.bind(this))
        .catch((e) => console.log(e))
    },

    loadWidgets (sectionId = null, customContent = false){
      var params = { params: {} }
      if (sectionId === null && this.sections.length > 0){
        sectionId = this.sections[this.currentTab].id
      }
      if (sectionId){
        params.params.section_id = sectionId
      , this.downloadPPTX}
      this.$eventBus.$emit('selectSection', sectionId)
      if (customContent) {
        this.$root.$emit('customContent', true)
        return
      }
      this.$http.get('/dashboards/'+ this.$route.params.id +'/widgets', params)
        .then(response => this.showWidgets(response))
        .catch((e) => console.log(e))
    },

    showWidgets (response) {
      this.widgets = []
      this.$nextTick(() => {
        response.data.data.forEach((widget) => {
          this.widgets.splice(1,0,{
            id: parseInt(widget.id, 10),
            title: widget.attributes.title,
            widget_titles: widget.attributes.widget_titles.map((title) => title.title),
            type: widget.attributes.widget_type + 'Widget',
            dashboard_id: this.$route.params.id,
            audits: widget.attributes.audits,
            x: widget.attributes.grid_position.x,
            y: widget.attributes.grid_position.y,
            w: widget.attributes.grid_position.w,
            h: widget.attributes.grid_position.h,
            shared: widget.attributes.shared,
            filters: widget.attributes.filters,
            options: widget.attributes.options,
            owner_id: widget.attributes.owner_id,
            locked: widget.attributes.locked,
            disableLegend: widget.attributes.disable_legend,
            disableDataComparison: widget.attributes.disable_data_comparison,
            sectionIds: widget.attributes.section_ids,
            stacked_barchart: widget.attributes.data.stacked_barchart,
            funnel_order: widget.attributes.data.reverse_funnel,
            as_pyramid: widget.attributes.data.as_pyramid,
            click_through_section: widget.attributes.data.click_through_section,
            click_through: widget.attributes.data.click_through,
            state_history: widget.attributes.data.state_history,
            hide_table_controls: widget.attributes.data.hide_table_controls,
            hide_metric_label: widget.attributes.data.hide_metric_label,
            use_doughnut_percentages: widget.attributes.data.use_doughnut_percentages
          })
        })
      })
    },

    error (text) {
      this.$toasted.show(text, {
        duration: 3000,
        position: 'top-center',
        theme: "bubble"
      })
    },

    nextSection () {
      this.currentTab < (this.sections.length - 1) ? this.currentTab++ : this.currentTab = 0
      this.currentTabModel = this.sections[this.currentTab]
      this.loadWidgets(this.sections[this.currentTab].id)
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },

    prevSection () {
      this.currentTab === 0 ? this.currentTab = this.sections.length - 1 : this.currentTab--
      this.currentTabModel = this.sections[this.currentTab]
      this.loadWidgets(this.sections[this.currentTab].id)
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },

    quickDatePicker (date) {
      this.$store.commit('setStartDate', date)
      this.$store.commit('setEndDate', Moment())
      this.$eventBus.$emit('reloadWidgets')
    },

    showQuickDate () {
      let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
       + window.innerHeight === document.documentElement.offsetHeight

      this.hideQuickDate = bottomOfWindow ? true : false
    }
  }
}
</script>

<style scoped>
  /* IE fix */
#card-chart-01, #card-chart-02 {
  width: 100% !important;
}
.card {
  margin-bottom: 0;
  height: 100%;
  overflow: auto;
  border: none;
}
.card .card-header {
  border: none;
}
.card .table-responsive-sm {
    overflow: auto;
}
.bottom-nav {
  width: calc(100% - 66px);
  padding: 0 15px;
}
.bottom-nav a {
  color: #3493B2;
  font-family: 'Cooper Hewitt Book';
  cursor: pointer;
  margin: 30px auto;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
.bottom-nav .left {
  float: left;
}
.bottom-nav .right {
  float: right;
  text-align: right;
}
.bottom-nav .left:hover {
  -webkit-transform: translateX(-5px);
  transform: translateX(-5px);
  color: #47889c;
}
.bottom-nav .right:hover {
  -webkit-transform: translateX(5px);
  transform: translateX(5px);
  color: #47889c;
}
@media (min-width: 786px) {
  .bottom-nav .left {
    padding-left: 50px;
  }
}
#quick-date-picker {
  width: 500px;
  box-shadow: 0px 2px 5px #888888;
  border-radius: 10px;
  position: fixed;
  left: 250px;
  right: 0;
  bottom: 15px;
  z-index: 999;
  background: #fff;
  opacity: 1;
  transition: all 0.5s;
}
#quick-date-picker .nav-link {
  color: #3796b4;
  transition: all 0.2s;
  padding: 2px 6px;
  margin: 8px;
  font-weight: 500;
}
#quick-date-picker .nav-link:hover {
  color: #fff;
  background: #3796b4;
}
.hide-quick-date {
  visibility: hidden;
  opacity: 0 !important;
}
</style>
<style>
  .custom-content.top-nav-tabs .nav-tabs {
    display: none;
  }
  .tab-content {
    background: transparent;
    border: none;
  }
  .tab-content .tab-pane {
    padding: 0;
  }
  .nav-tabs {
    display: block;
    margin: auto;
    border-bottom: 0px solid #fff;
    text-align: center;
  }
  .modal-body .nav-tabs {
    display: flex;
    text-align: left;
  }
  .nav-tabs .nav-item {
    display: inline-block;
  }
  .nav-tabs .nav-link {
    font-family: 'Cooper Hewitt Medium';
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  .nav-tabs .nav-link.active, .nav-tabs .nav-link.active:focus {
    background: transparent;
    border-color: transparent !important;
  }
  .nav-tabs .nav-link:hover {
    color: #3493B2;
    border-bottom-color: transparent;
  }
  .nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
    border-color: transparent;
  }
  .nav-tabs .nav-link:after {
    content: "";
    display: block;
    width: calc(100% + 30px);
    margin-left: -15px;
    transform: translateY(8px);
    height: 3px;
    background-color: transparent;
    position: relative;
    -webkit-transition: all 0.3s ease;
		-moz-transition: all 0.3s ease;
		-o-transition: all 0.3s ease;
		transition: all .3s ease;
  }
  .nav-tabs .nav-link.active:after {
    content: "";
    display: block;
    width: calc(100% + 30px);
    margin-left: -15px;
    transform: translateY(8px);
    height: 3px;
    background-color: #3493B2;
    position: relative;
    -webkit-transition: all 0.3s ease;
		-moz-transition: all 0.3s ease;
		-o-transition: all 0.3s ease;
		transition: all .3s ease;
 }
 .modal-body .nav-tabs {
    margin-bottom: 15px;
  }
  .chartjs-tooltip {
    position: fixed;
  }
  #ad-preview-modal img {
    width: 100% !important;
  }
  #ad-preview-modal .modal-content {
    width: 570px;
  }
  .card {
    border: none;
    border-radius: 6px;
  }
  .card .card-header {
    border: none;
  }
  .card .card-header .widget-title {
    font-family: 'Cooper Hewitt Semibold';
    text-transform: uppercase;
    color: #5d5f61;
    letter-spacing: 2px;
  }
  .closed #quick-date-picker {
    left: 0;
  }
  /* .vue-grid-item .card-body {
    margin-top: 3rem;
  } */
</style>
